import { PERMISSIONS } from "@/utils/constants";
import authMiddleware from "@/router/middlewares/authMiddleware";
import permissionMiddleware from "@/router/middlewares/permissionMiddleware";

export default [
  {
    path: "/history",
    name: "history-index",
    component: () => import("../pages/admin/history/index"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.HISTORY)],
    },
  },
  {
    path: "/history/contracts",
    name: "contract-history",
    component: () => import("../pages/admin/history/contract/index"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.HISTORY)],
    },
  },
  {
    path: "/history/contracts/item",
    name: "contract-history-item",
    component: () => import("../pages/admin/history/contract/item"),
    // meta: {
    //     middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.HISTORY)],
    // },
  },
  {
    path: "/history/orders",
    name: "order-history",
    component: () => import("../pages/admin/history/order/index"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.HISTORY)],
    },
  },
  {
    path: "/history/orders/item",
    name: "order-history-item",
    component: () => import("../pages/admin/history/order/item"),
    meta: {
      middleware: [authMiddleware],
      // middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.HISTORY)], toDO
    },
  },
  {
    path: "/product-history",
    name: "product-history",
    component: () => import("../pages/admin/history/product/index"),
    meta: {
      middleware: [authMiddleware],
    },
  },
  {
    path: "/product/code",
    name: "product-code",
    component: () => import("../pages/admin/product/code"),
    meta: {
      middleware: [authMiddleware, permissionMiddleware(PERMISSIONS.HISTORY)],
    },
  },
];
